function formatDecimalInput(value, allowNegative, maximumFractionDigits) {
    let sign = '';
    let text = String(value);
    if (allowNegative && text.charAt(0) === '-') {
        sign = '-';
    }
    text = text.replace(/[^\d.]/g, '');
    text = text.replace(/\.{2,}/g, '.');
    text = text.replace(/^\./g, '');
    text = text.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.');
    const decimalIndex = text.indexOf('.');
    if (decimalIndex !== -1) {
        text = text.substring(0, decimalIndex + 1 + maximumFractionDigits);
    }
    return sign + text;
}

export function formatNow(e) {
    //先把非数字的都替换掉，除了数字和.
    e.target.value = e.target.value.replace(/[^\d.]/g, "");
    //保证只有出现一个.而没有多个.
    e.target.value = e.target.value.replace(/\.{2,}/g, ".");
    //必须保证第一个为数字而不是.
    e.target.value = e.target.value.replace(/^\./g, "");
    // e.target.value = e.target.value.replace(/^0/g, "");
    //保证.只出现一次，而不能出现两次以上
    e.target.value = e.target.value.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
    //只能输入两个小数
    e.target.value = e.target.value.replace(/^(-)*(\d+)\.(\d\d\d\d).*$/, '$1$2.$3');
    return 11;
}

export function formatUnsignedAmountNow(e) {
    e.target.value = formatDecimalInput(e.target.value, false, 5);
}

export function formatSignedRateNow(e) {
    e.target.value = formatDecimalInput(e.target.value, true, 4);
}

export function formatAtCreate(e) {
    if (e == "") {
        return 0;
    }
    e = e + "";
    //先把非数字的都替换掉，除了数字和.
    e = e.replace(/[^\d.]/g, "");
    //保证只有出现一个.而没有多个.
    e = e.replace(/\.{2,}/g, ".");
    //必须保证第一个为数字而不是.
    e = e.replace(/^\./g, "");
    //保证.只出现一次，而不能出现两次以上
    e = e.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
    //只能输入两个小数
    e = e.replace(/^(-)*(\d+)\.(\d\d\d\d).*$/, '$1$2.$3');

    return e;
}

export function formatUnsignedAmountAtCreate(value) {
    if (value === '') {
        return 0;
    }
    return formatDecimalInput(value, false, 5);
}

export function formatUnsignedPercentageAtCreate(value) {
    if (value === '') {
        return 0;
    }
    return formatDecimalInput(value, false, 3);
}

export function formatSignedRateAtCreate(value) {
    if (value === '') {
        return 0;
    }
    return formatDecimalInput(value, true, 4);
}
